// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-side[data-v-32dbb442]{width:420px}.layout-content[data-v-32dbb442]{max-width:768px}.fade-enter-active[data-v-32dbb442],.fade-leave-active[data-v-32dbb442]{transition-duration:.2s;transition-property:opacity;transition-timing-function:ease}.fade-enter[data-v-32dbb442],.fade-leave-active[data-v-32dbb442]{opacity:0}.catamaran[data-v-32dbb442]{font-family:\"Catamaran\",sans-serif!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
